import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

const bootstrap = require('bootstrap')
window.bootstrap = bootstrap;

import ls from 'localstorage-slim';
window.ls = ls;
ls.config.encrypt = true;

import QRCodeStyling from 'qr-code-styling';
window.QRCodeStyling = QRCodeStyling;

var matched, browser;

jQuery.uaMatch = function( ua ) {
    ua = ua.toLowerCase();

    var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
        /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
        /(msie) ([\w.]+)/.exec( ua ) ||
        ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
        [];

    return {
        browser: match[ 1 ] || "",
        version: match[ 2 ] || "0"
    };
};

matched = jQuery.uaMatch( navigator.userAgent );
browser = {};

if ( matched.browser ) {
    browser[ matched.browser ] = true;
    browser.version = matched.version;
}

// Chrome is Webkit, but Webkit is also Safari.
if ( browser.chrome ) {
    browser.webkit = true;
} else if ( browser.webkit ) {
    browser.safari = true;
}

window.$.browser = browser;

const Swal = require('sweetalert2')
window.Swal = Swal;

import PerfectScrollbar from 'perfect-scrollbar';

window.formatBytes = function(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

window.truncateText = (input, max) => input.length > max ? `${input.substring(0, max)}...` : input;

window.rupiah = (nStr, inD = '.', outD = '.', sep = ',') => {
    nStr += '';
    var dPos = nStr.indexOf(inD);
    var nStrEnd = '';
    if (dPos != -1) {
        nStrEnd = outD + nStr.substring(dPos + 1, nStr.length);
        nStr = nStr.substring(0, dPos);
    }
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(nStr)) {
        nStr = nStr.replace(rgx, '$1' + sep + '$2');
    }
    var result = nStr + nStrEnd;
    return result;
}

window.resetInput = (element) => {
    var tag = $(element).prop("tagName"), type = $(element).attr("type");

    if(tag === 'INPUT' || tag === 'TEXTAREA'){
        if(type === 'radio'){
            $(element).prop('checked', function() {
            return this.defaultChecked;
            });
        } else {
            $(element).val(function(){
            return this.defaultValue;
            });
        }
    } else if(tag === 'SELECT') {
        $(element).find('option').prop('selected', function() {
            return this.defaultSelected;
        });
    }
}

(function() {
    window.AutoScroll = function(el, options) {

        if (!(this instanceof AutoScroll)) {
            return new AutoScroll(el, options);
        }

        this.el = el;
        this.speed = null;
        this.isBeingThrown = false;
        this.isMouseOver = false;
        this.isRunning = false;
        this.thrownInterval = null;
        this.timeout = null;
        this.previousScrollTop = null;

        var defaults = {
            speed: 10,
            pauseBottom: 500,
            pauseStart: 500,
                requestAnimationFrame: true,
                timeoutRate: 30
            };

        if (options && typeof options === 'object') {
            this.options = extendDefaults(defaults, options);
        } else {
            this.options = defaults;
        }

        _init.call(this);
    }

    AutoScroll.prototype.autoScroll = function() {
        if (this.isRunning && !this.isBeingThrown && !this.isMouseOver) {
            if (this.el.scrollTop < this.el.scrollHeight - this.el.offsetHeight) {
                    if(this.options.requestAnimationFrame) {
                        this.el.scrollTop += this.speed;
                        window.requestAnimationFrame(this.autoScroll.bind(this));
                    } else {
                        this.el.scrollTop += this.speed;
                        if (this.timeout) clearTimeout(this.timeout);
                        this.timeout = setTimeout(this.autoScroll.bind(this), this.options.timeoutRate)
                    }
            } else {
                this.isRunning = false;
                setTimeout(this.resetScroll.bind(this), this.options.pauseBottom);
            }
        } else {
            return;
        }
    }

    AutoScroll.prototype.startScroll = function() {
        this.isRunning = true;
        this.autoScroll.call(this);
    }

    AutoScroll.prototype.resetScroll = function() {
        this.el.scrollTop = 0;
        setTimeout(this.startScroll.bind(this), this.options.pauseStart);
    }

    AutoScroll.prototype.mouseLeave = function(e) {
        this.isMouseOver = false;
        this.isRunning = true;
        this.startScroll.call(this);
    }

    function _init() {
        this.speed = _setSpeed(this.options.speed);
        _initEvents.call(this);
        setTimeout(this.startScroll.bind(this), this.options.pauseStart);
    }

    function _initEvents() {
        this.el.addEventListener('mouseleave', this.mouseLeave.bind(this));
    }

    function _setSpeed(scrollDistance) {
        return Math.ceil(scrollDistance / 60);
    }

    function extendDefaults(source, properties) {
        var property;
        for (property in properties) {
            if (properties.hasOwnProperty(property)) {
                source[property] = properties[property];
            }
        }
        return source;
    }
})();

$(function () {
    $('.ps-container').each(function () {
       const ps = new PerfectScrollbar($(this)[0]);
    });

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-inViewport');
            if (!entry.target.hasAttribute("data-viewport-keep")) {
                observer.unobserve(entry.target);
            }
        });
    });

    const obsOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
    };

    const ELs_inViewport = document.querySelectorAll('[data-inviewport]');
    ELs_inViewport.forEach(EL => {
        observer.observe(EL, obsOptions);
    });

    window.scrollBack = (target) => {
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 500);
    }   

    $('.p-vertical-wizard .collapse').on('show.bs.collapse', function(){
      var index = $('.p-vertical-wizard .collapse').index(this);

      $('.p-vertical-wizard .vw-item').each(function(i) {
        
        if(i < index){
            $(this).addClass('done');
            $(this).find('.vw-number span').hide();            
        } else {
            $(this).removeClass('done');
            $(this).find('.vw-number span').show();  
        }

        if(i == index){
            $(this).addClass('active');
            $(this).find('.vw-label').removeClass('collapsed');
        }else{
            $(this).removeClass('active');
            $(this).find('.vw-label').addClass('collapsed');
        }
      });
    });

    window.Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
    
    window.Msg = Swal.mixin({
        customClass: {
            confirmButton: 'black-button px-4'
        }
    })

    window.getData = (target, loader, form) => {

        var form = $(form);
        var url = form.attr('action'),
            param = form.serialize();
                
        $(target).html($(loader).html());
      
        return $.ajax({
            type: "GET",
            url: url,
            data: param,
            success: function(data)
            {
                $(target).html(data);
            },
            error: function(xhr, status, error) {        
                console.log(xhr.responseText);
            }
        });
    }

    window.getByUrl = (target, loader, url, param = {}) => {
      $(target).html($(loader).html());

      return $.ajax({
        type: "GET",
        url: url,
        data: param,
        success: function(data)
        {
            $(target).html(data);
        }
      });
    }

    window.postModal = async (trigger) => {
      let form = $($(trigger).data('form')),
      loader = $(trigger).data('loader'),
      target = $(trigger).data('target');

        return await new Promise((resolve, reject) => {
            if ($(form).valid()) {
                $(target).html($(loader).html());

                form.ajaxForm({
                    beforeSend: () => {
                        $(trigger).addClass('loading');
                    },
                    success: (data) => {
                        if ($(trigger).parents('.modal')) {                 
                            $(trigger).parents('.modal').modal('hide');
                        }
                        
                        $(target).html(data);
                                    
                        $(trigger).removeClass('loading');

                        resolve(data);
                    },
                    error: (error) => {
                        $(trigger).removeClass('loading');
                        console.log(error);
                        reject(error);
                    }
                }).submit();         
            } else {
                reject('invalid form');
            }
        }); 
    }

    window.postData = async (trigger, target, loader, form) => {
        return await new Promise((resolve, reject) => {
            if ($(form).valid()) {
                $(target).html($(loader).html());

                form.ajaxForm({
                    beforeSend: () => {
                        $(trigger).addClass('loading');
                    },
                    success: (data) => {
                        if ($(trigger).parents('.modal')) {                 
                            $(trigger).parents('.modal').modal('hide');
                        }
                        
                        $(target).html(data);
                                    
                        $(trigger).removeClass('loading');

                        resolve(data);
                    },
                    error: (error) => {
                        $(trigger).removeClass('loading');
                        console.log(error);
                        reject(error);
                    }
                }).submit();
            } else {
                reject('invalid form');
            }            
        });          
    }

    window.postForm = async (trigger, form) => {
        return await new Promise((resolve, reject) => {
            let url = $(form).attr('action'),
                data = $(form).serialize();

            $(trigger).addClass('loading');

            $.ajax({
                type: "POST",
                url: url,
                data: data,
                success: function (data) {                     
                    $(trigger).removeClass('loading');

                    resolve(data);
                },
                error: (error) => {
                    $(trigger).removeClass('loading');
                    console.log(error);
                    reject(error);
                }
            });       
        });          
    }

    window.saveForm = (form) => {
        let loader = form.find('.loader-autosave');
        
        loader.show();
        
        return $.ajax({
            type: "POST",
            url: form.attr('action'),
            data: form.serialize(),
            success: function (data) {
                loader.hide();
            },
            error: (error) => {
                loader.hide(); 
                console.log(error);
            }
        });
    }

    window.resetForm = (target) => {     
        $(target).find(':input').each(function() {
            switch (this.type) {
                case 'password':
                case 'select-multiple':
                case 'select-one':
                case 'text':
                case 'email':
                case 'number':
                case 'textarea':
                    $(this).val('');
                    break;
                case 'checkbox':
                case 'radio':
                    this.checked = false;
            }
        });

        $('.selectpicker').selectpicker('refresh');
    }

    window.filter_select_ajax = (target, data, url) => {
        if ($(target).hasClass('selectpicker')) {
            $(target).next('.dropdown-toggle').addClass('loading');
        } else {
            $(target).addClass('loading');
        }
        $(target).prop('disabled', true);

        return $.ajax({
            url: url,
            data: data,
            success: function (e) {
                $(target).prop('disabled', false);
                $(target).html(e);  
                if($(target).hasClass('selectpicker')){
                    $(target).selectpicker('refresh');
                    $(target).next('.dropdown-toggle').removeClass('loading');
                } else{
                  $(target).removeClass('loading');
                }
            },
            error: function(xhr, status, error) {
                console.log(xhr.responseText);
            }
        });
    }

    window.searchByElement = (input, list, textElement) => {
        $(input).on('input', function(e){
            var filter = $(this).val().toUpperCase(),
            element = $(list),
            el, txtValue;

            element.each(function( index ) {
                el = $(this);
                txtValue = el.find(textElement).text().trim()
                if (!(txtValue.toUpperCase().indexOf(filter) > -1)) {
                    el.hide();
                }else{
                    el.show();
                }
            });
        });
    }
});